import { useCallback, useMemo, useState } from "react";

type TranslatedContentPair = {
  value?: string | null;
  original?: string | null;
};

const isDifferentOriginal = ({ value, original }: TranslatedContentPair) =>
  typeof original === "string" &&
  original.trim() !== "" &&
  original.trim() !== (value ?? "").trim();

export const useOriginalContentToggle = (pairs: TranslatedContentPair[]) => {
  const [showOriginal, setShowOriginal] = useState(false);
  const canToggleOriginal = pairs.some(isDifferentOriginal);

  const toggleOriginal = useCallback(
    () => setShowOriginal((current) => !current),
    [],
  );

  const getVisibleContent = useCallback(
    (value?: string | null, original?: string | null) =>
      showOriginal && typeof original === "string" ? original : (value ?? ""),
    [showOriginal],
  );

  return useMemo(
    () => ({
      showOriginal,
      canToggleOriginal,
      toggleOriginal,
      getVisibleContent,
    }),
    [showOriginal, canToggleOriginal, toggleOriginal, getVisibleContent],
  );
};
